export default __webpack_public_path__ + "static/media/social-care.0609ad6d.png";